import { render, staticRenderFns } from "./areaChargesSet.vue?vue&type=template&id=1f070896&"
import script from "./areaChargesSet.vue?vue&type=script&lang=js&"
export * from "./areaChargesSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports